/** Shared request identity and visible-area rules for restaurant cards and pins. */
export function listingViewport(filter: any): { north: number; south: number; east: number; west: number } | null {
  const keys = ['north', 'south', 'east', 'west'];
  if (keys.some(key => filter?.[key] == null || filter[key] === '' || !Number.isFinite(Number(filter[key])))) return null;
  const [north, south, east, west] = keys.map(key => Number(filter[key]));
  if (north <= south || north > 90 || south < -90 || Math.abs(east) > 180 || Math.abs(west) > 180 || east === west) return null;
  return { north, south, east, west };
}

export function isInListingViewport(point: any, filter: any): boolean {
  if (point?.lat == null || point?.lng == null) return false;
  const lat = Number(point.lat), lng = Number(point.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  const bounds = listingViewport(filter);
  if (!bounds) return true;
  const longitudeInside = bounds.west <= bounds.east
    ? lng >= bounds.west && lng <= bounds.east
    : lng >= bounds.west || lng <= bounds.east;
  return lat >= bounds.south && lat <= bounds.north && longitudeInside;
}

export function listingQueryKey(filter: any): string {
  const numeric = ['origin_Lat', 'origin_long', 'zoomLevel', 'north', 'south', 'east', 'west'];
  const filters = ['search', 'FilterByRating', 'FilterByPriceRange', 'FilterByMealType', 'FilterByCategories', 'isForTest'];
  return JSON.stringify([
    ...numeric.map(key => filter?.[key] == null || filter[key] === '' ? null : Number(Number(filter[key]).toFixed(6))),
    ...filters.map(key => filter?.[key] ?? null)
  ]);
}

export interface ListingLoadResult {
  filter: any;
  coordinates: any[];
  total: number;
}
